import { combineReducers } from '@reduxjs/toolkit';
import { intlReducer } from 'react-intl-redux';

import Users from './Users';
import AppReducer from './AppReducer';
import SubmissionReducer from './SubmissionReducer';
import SurveyReducerV2 from './SurveyV2Reducer';
import TrialReducer from './TrialReducer';
import ReviewReducer from './reviewReducer';
import TrialCategoriesReducer from './TrialCategoriesReducer';
import VoucherReducer from './VoucherReducer';
import ReviewCategoryReducer from './ReviewCategoryReducer';
import FeedbackReducer from './FeedbackReducer';
import InstituteReducer from './InstituteReducer';
import PageStateReducer from './PageStateReducer';
import GroundTruthReducer from './GroundTruthReducer';
import SurveyDataReducer from './SurveyDataReducer';
import TrialTagReducer from './TrialTagReducer';
import PublicSharedLinkReducer from './PublicSharedLinkReducer';
import FaerbungReviewReducer from './FaerbungReviewReducer';

export const initialState = {};

/**
 * NOTE:
 *
 * To set the type of root redux state
 * src/redux/types/RootReduxState.ts
 */

const createRootReducer = (): any => combineReducers({
  app: AppReducer,
  users: Users,
  submission: SubmissionReducer,
  surveyV2: SurveyReducerV2,
  trial: TrialReducer,
  review: ReviewReducer,
  intl: intlReducer,
  trialCategories: TrialCategoriesReducer,
  reviewCategory: ReviewCategoryReducer,
  voucher: VoucherReducer,
  feedback: FeedbackReducer,
  institute: InstituteReducer,
  pageState: PageStateReducer,
  groundTruth: GroundTruthReducer,
  SurveyData: SurveyDataReducer,
  trialTag: TrialTagReducer,
  faerbungReview: FaerbungReviewReducer,
  publicSharedLink: PublicSharedLinkReducer,
});

export default createRootReducer;
